import { useEffect } from 'react';
import { Text } from 'react-native';
import Animated, {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';

export const WavingHand = () => {
  const progress = useSharedValue(0);
  useEffect(() => {
    progress.value = withRepeat(withTiming(1, { duration: 250 }), 8, true);
  }, [progress]);

  const animated = useAnimatedStyle(() => {
    const rotate = interpolate(progress.value, [0, 1], [0, Math.PI / 8]);
    const translateY = interpolate(progress.value, [0, 1], [0, -12]);
    return {
      transform: [{ rotate: `${rotate}rad` }, { translateY: translateY }],
    };
  });

  return (
    <Animated.View style={animated}>
      <Text style={{ fontSize: 32, paddingBottom: 10 }}>👋🏻</Text>
    </Animated.View>
  );
};
